// src/pages/MainPage.tsx 또는 src/pages/VisitorPage.tsx

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import VisitorForm from '../components/VisitorForm';
import VisitorList from '../components/VisitorList';

// Page 컴포넌트도 React.FC를 사용하여 타입을 명시합니다.
const Visitor: React.FC = () => {
    const [numToEdit, setNumToEdit] = useState<number | null>(null);
    const [refreshTrigger, setRefreshTrigger] = useState<number>(0);
    const [isListVisible, setIsListVisible] = useState<boolean>(true); 

    // 폼 완료 후 (등록/수정) 호출되어 목록을 새로고침
    const handleFormCompletion = () => {
        setNumToEdit(null); // 폼을 등록 모드로 되돌림
        setRefreshTrigger(prev => prev + 1); // 리스트 새로고침 유발
        setIsListVisible(true); // ★ 핵심 수정: 폼 완료 후 리스트 뷰로 자동 전환
    };
    
    // 리스트에서 '수정' 버튼 클릭 시 폼에 전달할 num 설정
    const handleEditClick = (num: number) => {
        setNumToEdit(num);
        setIsListVisible(false);
        window.scrollTo(0, 0); // 사용자 편의를 위해 페이지 상단으로 이동
    }

    // 2. 토글 핸들러 함수 정의
    const handleToggleView = () => {
        setNumToEdit(null); // 수정 모드 해제
        setRefreshTrigger(prev => prev); // 리스트 새로고침
        setIsListVisible(!isListVisible);
    };
    const navigate = useNavigate();

    const handleMainPage = () => {
        navigate('/main'); 
    };  
    return (
        // 부트스트랩 컨테이너 적용 (화면 중앙에 적절한 너비로 배치)
        <div className="container py-5"> 
            <h1 className="text-center mb-4">방문자 관리 시스템</h1>

            {/* 폼 컴포넌트: numToEdit을 통해 수정/등록 모드 전환 */}
            {/* <VisitorForm 
                numToEdit={numToEdit} 
                onComplete={handleFormCompletion} 
            /> */}

            {/* 3. 토글 버튼 추가 및 텍스트 변경 */}
            <div className="d-grid gap-2 col-md-6 mx-auto mb-5"> {/* 버튼 중앙 정렬 및 너비 조정 */}
                <button 
                    onClick={handleMainPage}
                    className={`btn btn-lg btn-secondary`}
                    //style={{ marginBottom: '20px', padding: '10px 20px' }} // 스타일은 예시
                >
                    메인 페이지 이동
                </button>

                <br></br><br></br>

                <button 
                    onClick={handleToggleView}
                    className={`btn btn-lg ${isListVisible ? 'btn-success' : 'btn-warning'}`} // 토글 상태에 따라 버튼 색상 변경
                    //style={{ marginBottom: '20px', padding: '10px 20px' }} // 스타일은 예시
                >
                    {/* isListVisible 상태에 따라 버튼 텍스트 변경 */}
                    {isListVisible ? '➡️ 방문자 등록 페이지로 이동' : '⬅️ 검색 및 수정 페이지로 이동'}
                </button>
            </div>

            <hr />

            {/* 4. isListVisible 상태에 따라 폼/리스트 조건부 렌더링 */}
            {isListVisible ? (
                // 목록 및 검색/수정 활성화 (기존 VisitorList가 보여야 함)
                <VisitorList 
                    onEdit={handleEditClick} 
                    refreshTrigger={refreshTrigger} 
                />
            ) : (
                // 등록 페이지 활성화 (VisitorForm이 등록 모드로 보여야 함)
                <VisitorForm 
                    numToEdit={numToEdit} // 등록 모드 확정을 위해 명시적으로 null 전달
                    onComplete={handleFormCompletion} 
                />
            )}

        </div>
    );
};

export default Visitor;